import { render } from "./StartGame.vue?vue&type=template&id=c6bd8790"
import script from "./StartGame.vue?vue&type=script&lang=js"
export * from "./StartGame.vue?vue&type=script&lang=js"

import "./StartGame.vue?vue&type=style&index=0&id=c6bd8790&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__